import axios from "../axiosInstance";
import { CreateAddressChangeRequestRequest } from "./types";

export const createAddressChangeRequest = async (
  payload: CreateAddressChangeRequestRequest,
): Promise<void> => {
  await axios.post(
    "/api/private/my-company-profile/address-change-request",
    payload,
  );
};
